// common permissions
let oldPermissions = [
    {
        title: 'Alerts',
        perms: [
            { value: 'read-alert', type: 'Standard', name: 'View alerts/metadata' },
            { value: 'update-alert', type: 'Standard', name: 'Update alerts/metadata' },
            { value: 'read-incident', type: 'Standard', name: 'View incidents' },
            { value: 'update-incident', type: 'Standard', name: 'Update incidents' },
        ],
    },
    {
        title: 'Sensors',
        perms: [
            { value: 'read-sensor', type: 'Standard', name: 'View sensors' },
            { value: 'update-sensor', type: 'Privileged', name: 'Update sensors' },
        ],
    },
    {
        title: 'Users and Roles',
        perms: [
            { value: 'read-user', type: 'Standard', name: 'View users' },
            { value: 'update-user', type: 'Privileged', name: 'Update users' },
        ],
    },
    {
        title: 'System',
        perms: [
            { value: 'read-system', type: 'Standard', name: 'Read system' },
            { value: 'update-system', type: 'Privileged', name: 'Update system' },
        ],
    },
];

// uncommon permissions
oldPermissions = process.env.BRICATA_APPLIANCE_TYPE === 'mc2'
    ? [
        ...oldPermissions,
        {
            title: 'Others',
            perms: [
                { value: 'read-audit', type: 'Standard', name: 'View audit' },
                { value: 'request-pcap', type: 'Standard', name: 'Request PCAP' },
                { value: 'override-pcap', type: 'Privileged', name: 'Override PCAP' },
            ],
        },
        {
            title: 'CMC',
            perms: [
                { value: 'read-cmc', type: 'Standard', name: 'View CMC' },
                { value: 'update-cmc', type: 'Standard', name: 'Update CMC' },
            ],
        }
    ] : [
        ...oldPermissions,
        {
            title: 'Others',
            perms: [
                { value: 'read-audit', type: 'Standard', name: 'View audit' },
                { value: 'request-pcap', type: 'Standard', name: 'Request PCAP' },
                { value: 'override-pcap', type: 'Privileged', name: 'Override PCAP' },
                { value: 'override-mc2', type: 'Privileged', name: 'Override MC2 Policy' },
            ],
        },
    ];

const Permissions = {
    Policies: {
        Sensor: {
            GeoIPPolicy: ['read', 'write', 'delete', 'admin', 'override'],
            ExportsPolicy: ['read', 'write', 'delete', 'admin', 'override'],
            PcapPolicy: ['read', 'write', 'delete', 'admin', 'override'],
            DataTuningPolicy: ['read', 'write', 'delete', 'admin', 'override'],
            FileHashPolicy: ['read', 'write', 'delete', 'admin', 'override'],
            ConfigPolicy: ['read', 'write', 'delete', 'admin', 'override'],
            UpgradePolicy: ['read', 'write', 'delete', 'admin', 'override'],
        },
        Suricata: {
            SuricataRulesPolicy: ['read', 'write', 'delete', 'admin', 'override'],
            SuricataVarsPolicy: ['read', 'write', 'delete', 'admin', 'override'],
            SuricataRules: ['read', 'write', 'delete', 'admin', 'override'],
        },
        Zeek: {
            ZeekScriptsPolicy: ['read', 'write', 'delete', 'admin', 'override'],
            ZeekScripts: ['read', 'write', 'delete', 'admin'],
            ThreatIntelPolicy: ['read', 'write', 'delete', 'admin', 'override'],
            ThreatIntelIndicators: ['read', 'write', 'delete', 'admin'],
        },
    },
    Sensors: ['read', 'write', 'delete', 'admin', 'override'],
    Cluster: ['read', 'write', 'delete', 'admin'],
    CMC: ['read', 'write', 'delete', 'admin', 'override'],
    System: {
        Users: ['read', 'write', 'delete', 'admin', 'override'],
        Roles: ['read', 'write', 'delete'],
        SystemHealth: ['read', 'write'],
        Audit: ['read', 'write'],
        Reports: ['read', 'write', 'delete', 'admin'],
        License: ['read', 'write', 'admin'],
        Configuration: {
            AuditExport: ['read', 'write', 'admin'],
            AuthenticationStandard: ['read', 'write'],
            AuthenticationPrivileged: ['read', 'write'],
            AuthenticationExternal: ['read', 'write', 'admin'],
            CMCExport: ['read', 'write', 'admin'],
            HealthAlerts: ['read', 'write', 'delete'],
            Mail: ['read', 'write'],
            Proxy: ['read', 'write'],
            ReportsConfig: ['read', 'write'],
            SNMP: ['read', 'write'],
            UI: ['read', 'write'],
            VPN: ['read', 'write', 'admin', 'override'],
            Support: ['read', 'write', 'admin'],
            WebServer: ['read', 'write', 'admin'],
            MetadataIngest: ['read', 'write', 'admin', 'override'],
        },
        Mirroring: {
            AWS: ['read', 'write', 'delete', 'admin'],
            GCP: ['read', 'write', 'delete', 'admin'],
        },
        AnomalyDetection: {
            OpenSearchAnomalies: ['read', 'write', 'delete'],
        },
        Upgrades: {
            CMCUpgrades: ['read', 'write', 'delete', 'admin'],
            Mc2Upgrades: ['read', 'write', 'delete', 'admin'],
            DatanodeUpgrades: ['read', 'write', 'delete', 'admin'],
        },
    },
    Views: {
        Alerts: ['read', 'write', 'delete', 'admin', 'override'],
        Anomalies: ['read'],
        Metadata: ['read', 'write', 'delete'],
        Incidents: ['read', 'write', 'delete', 'admin'],
        Pcap: ['read', 'write', 'override'],
        Backtesting: ['read', 'write', 'delete', 'admin'],
    },
    Tags: ['read', 'write', 'delete'],
    Assets: ['read', 'write', 'delete', 'admin'],
    Dashboards: ['read', 'write', 'delete', 'override'],
    AccessKeys: ['write', 'admin'],
};

const MUITree = {
    Policies: {
        title: 'Policies',
        appliance: '',
        children: {
            Sensor: {
                title: 'Sensor',
                appliance: '',
                children: {
                    GeoIPPolicy: {
                        title: 'Geo IP',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    ExportsPolicy: {
                        title: 'Exports',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    PcapPolicy: {
                        title: 'Packet Capture',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    DataTuningPolicy: {
                        title: 'Data Tuning',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    FileHashPolicy: {
                        title: 'File Hash',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    ConfigPolicy: {
                        title: 'Configuration',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    UpgradePolicy: {
                        title: 'Upgrade',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                }
            },
            Suricata: {
                title: 'Suricata',
                appliance: '',
                children: {
                    SuricataRulesPolicy: {
                        title: 'Suricata Rules',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    SuricataVarsPolicy: {
                        title: 'Suricata Vars',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    SuricataRules: {
                        title: 'Suricata Rules Settings',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                }
            },
            Zeek: {
                title: 'Zeek',
                appliance: '',
                children: {
                    ZeekScriptsPolicy: {
                        title: 'Zeek Scripts Policy',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    ZeekScripts: {
                        title: 'Zeek Scripts Settings',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                        },
                    },
                    ThreatIntelPolicy: {
                        title: 'Threat Intelligence Policy',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    ThreatIntelIndicators: {
                        title: 'Threat Intelligence Settings',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' },
                        },
                    },
                }
            },
        }
    },
    Sensors: {
        title: 'Sensors',
        appliance: '',
        children: {
            Read: { title: 'Read' },
            Write: { title: 'Write' },
            Delete: { title: 'Delete' },
            Admin: { title: 'Admin' },
            Override: { title: 'Override' }
        },
    },
    Cluster: {
        title: 'Cluster',
        appliance: '',
        // Only show Delete/Admin for CMC, not MC2
        children: (() => {
            if (process.env.BRICATA_APPLIANCE_TYPE === 'mc2') {
                return {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' }
                };
            }
            return {
                Read: { title: 'Read' },
                Write: { title: 'Write' },
                Delete: { title: 'Delete' },
                Admin: { title: 'Admin' }
            };
        })(),
    },
    CMC: {
        title: 'CMC',
        appliance: 'mc2',
        children: {
            Read: { title: 'Read' },
            Write: { title: 'Write' },
            Delete: { title: 'Delete' },
            Admin: { title: 'Admin' },
            Override: { title: 'Override' }
        },
    },
    System: {
        title: 'System',
        appliance: '',
        children: {
            Users: {
                title: 'Users',
                appliance: '',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' },
                    Delete: { title: 'Delete' },
                    Admin: { title: 'Admin' },
                    Override: { title: 'Override' }
                },
            },
            Roles: {
                title: 'Roles',
                appliance: '',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' },
                    Delete: { title: 'Delete' }
                },
            },
            SystemHealth: {
                title: 'System Health',
                appliance: '',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' }
                },
            },
            Audit: {
                title: 'Audit',
                appliance: '',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' }
                },
            },
            Reports: {
                title: 'Reports',
                appliance: '',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' },
                    Delete: { title: 'Delete' },
                    Admin: { title: 'Admin' }
                },
            },
            License: {
                title: 'License',
                appliance: 'cmc',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' },
                    Admin: { title: 'Admin' }
                },
            },
            Configuration: {
                title: 'Configuration',
                appliance: '',
                children: {
                    AuditExport: {
                        title: 'Audit Export(s)',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Admin: { title: 'Admin' }
                        },
                    },
                    AuthenticationStandard: {
                        title: 'Authentication - Standard',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' }
                        },
                    },
                    AuthenticationPrivileged: {
                        title: 'Authentication - Privileged',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' }
                        },
                    },
                    AuthenticationExternal: {
                        title: 'Authentication - External',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Admin: { title: 'Admin' }
                        },
                    },
                    CMCExport: {
                        title: 'CMC Event Export(s)',
                        appliance: 'cmc',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                        },
                    },
                    HealthAlerts: {
                        title: 'Health',
                        appliance: 'cmc',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' }
                        },
                    },
                    Mail: {
                        title: 'Email',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' }
                        },
                    },
                    Proxy: {
                        title: 'Proxy',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' }
                        },
                    },
                    ReportsConfig: {
                        title: 'Reports',
                        appliance: 'cmc',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' }
                        },
                    },
                    SNMP: {
                        title: 'SNMP',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' }
                        },
                    },
                    UI: {
                        title: 'UI',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' }
                        },
                    },
                    VPN: {
                        title: 'VPN',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                    Support: {
                        title: 'OpenText™ NDR Support',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Admin: { title: 'Admin' }
                        },
                    },
                    WebServer: {
                        title: 'Web Server',
                        appliance: '',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Admin: { title: 'Admin' }
                        },
                    },
                    MetadataIngest: {
                        title: 'Metadata Ingest',
                        appliance: 'cmc',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Admin: { title: 'Admin' },
                            Override: { title: 'Override' }
                        },
                    },
                }
            },
            Mirroring: {
                title: 'Mirroring',
                appliance: 'cmc',
                children: {
                    AWS: {
                        title: 'AWS',
                        appliance: 'cmc',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' }
                        },
                    },
                    GCP: {
                        title: 'GCP',
                        appliance: 'cmc',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' }
                        },
                    },
                }
            },
            AnomalyDetection: {
                title: 'Anomaly Detection',
                appliance: 'cmc',
                children: {
                    OpenSearchAnomalies: {
                        title: 'OpenSearch Rules',
                        appliance: 'cmc',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                        },
                    },
                }
            },
            Upgrades: {
                title: 'Upgrades',
                appliance: '',
                children: {
                    CMCUpgrades: {
                        title: 'CMC',
                        appliance: 'cmc',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' }
                        },
                    },
                    Mc2Upgrades: {
                        title: 'MC2',
                        appliance: 'mc2',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' }
                        },
                    },
                    DatanodeUpgrades: {
                        title: 'Datanode',
                        appliance: 'cmc',
                        children: {
                            Read: { title: 'Read' },
                            Write: { title: 'Write' },
                            Delete: { title: 'Delete' },
                            Admin: { title: 'Admin' }
                        },
                    },
                }
            },
        },
    },
    Views: {
        title: 'Views',
        appliance: '',
        children: {
            Alerts: {
                title: 'Alerts',
                appliance: '',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' },
                    Delete: { title: 'Delete' },
                    Admin: { title: 'Admin' },
                    Override: { title: 'Override' }
                },
            },
            Metadata: {
                title: 'Metadata',
                appliance: '',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' },
                    Delete: { title: 'Delete' }
                },
            },
            Incidents: {
                title: 'Incident Response',
                appliance: 'cmc',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' },
                    Delete: { title: 'Delete' },
                    Admin: { title: 'Admin' }
                },
            },
            Pcap: {
                title: 'Packet Requests',
                appliance: '',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' },
                    Override: { title: 'Override' }
                },
            },
            Backtesting: {
                title: 'Backtesting',
                appliance: 'cmc',
                children: {
                    Read: { title: 'Read' },
                    Write: { title: 'Write' },
                    Delete: { title: 'Delete' },
                    Admin: { title: 'Admin' }
                },
            },
            Anomalies: {
                title: 'Anomalies',
                appliance: 'cmc',
                children: {
                    Read: { title: 'Read' }
                },
            },
        },
    },
    Tags: {
        title: 'Tags',
        appliance: '',
        children: {
            Read: { title: 'Read' },
            Write: { title: 'Write' },
            Delete: { title: 'Delete' }
        },
    },
    Assets: {
        title: 'Assets',
        appliance: '',
        children: {
            Read: { title: 'Read' },
            Write: { title: 'Write' },
            Delete: { title: 'Delete' },
            Admin: { title: 'Admin' }
        },
    },
    Dashboards: {
        title: 'Dashboards',
        appliance: '',
        children: {
            Read: { title: 'Read' },
            Write: { title: 'Write' },
            Delete: { title: 'Delete' },
            Override: { title: 'Override' }
        },
    },
    AccessKeys: {
        title: 'Access Keys',
        children: {
            Write: { title: 'Write' },
            Admin: { title: 'Admin' }
        },
    },
};

export {
    Permissions as default,
    oldPermissions,
    MUITree,
};
